import {Component, OnInit, ViewChild} from '@angular/core';
import {RiskService, RiskServiceBlockedCardsContainer} from '../../services/risk.service';
import {Card} from '../../../dto/card';
import {toDateString, toDateTimeString} from '../../../providers/app-date-adapter';
import {BankTransferLoad} from '../../../dto/bankTransferLoad';
import {CustomerRisk} from '../../../dto/customer-risk';
import {MultiCrudDataSource} from '../../../table-datasouces/multi-crud.datasource';
import {RoleService} from '../../../services/role.service';
import {Company} from '../../../dto/company';
import {CompanyService} from '../../services/company.service';
import {MatTableGeneratorComponent} from '../../../shared/mat-table-generator/mat-table-generator.component';

@Component({
  selector: 'app-blocked-cards',
  templateUrl: './blocked-cards.component.html',
  styleUrls: ['./blocked-cards.component.css']
})
export class BlockedCardsComponent implements OnInit {


  @ViewChild(MatTableGeneratorComponent, { static: true }) table: MatTableGeneratorComponent;

  constructor(
    private riskService: RiskService,
    private roleService: RoleService,
    private companyService: CompanyService
  ) { }

  columns = [

    { columnDef: 'token', header: 'Token', cell: (row: Card) => `${row.token}` },
    { columnDef: 'gpsCardStatus', header: 'GPS Status', cell: (row: Card) => `${row.gpsCardStatus}` },
    { columnDef: 'gpsCardStatusDate', header: 'GPS Status Date', cell: (row: Card) => `${toDateString(row.gpsCardStatusDate)}` },
    { columnDef: 'customer.firstName', header: 'First Name', cell: (row: Card) => `${row.customer.firstName}` },
    { columnDef: 'customer.lastName', header: 'Last Name', cell: (row: Card) => `${row.customer.lastName}` },
    { columnDef: 'product.name', header: 'Product', cell: (row: Card) => `${row.productName}` },
    { columnDef: 'status', header: 'Status', cell: (row: Card) => `${row.statusName}` },
    { columnDef: 'expireDate', header: 'Expiry Date', cell: (row: Card) => `${toDateString(row.expireDate)}` },
  ];
  dataSource = new MultiCrudDataSource(new RiskServiceBlockedCardsContainer(this.riskService));
  getRowClass = (item: Card): string => {
    const classes = [];

    // TODO implement this if necessary
    return classes.join(' ');
  };
  getCustomerOverviewLink = (item: Card): string => '/customers-overview/' + item.customerId.toString();
  companies: Company[] = [];


  ngOnInit(): void {

    this.companyService.getAll().subscribe(x => this.companies = x.data);

  }

  currentUserIsPartner() {
    return this.roleService.hasRoles('partner');
  }

  onSearch(isInvalid = false) {
    if (!isInvalid) {
      this.table.applyFilter();
    }
  }
}
